import React from 'react'
import styled from 'styled-components'
import { colors } from '../styleGuide'

export interface PixelPageContainerProps {
  width?: string
  height?: string
  maxHeight?: string
  minHeight?: string
  backgroundColor?: string
  padding?: string
  overflow?: string
  margin?: string
  children?: React.ReactNode
  style?: React.CSSProperties
}

const StyledPixelPageContainer = styled.div<
  Pick<
    PixelPageContainerProps,
    | 'width'
    | 'height'
    | 'maxHeight'
    | 'minHeight'
    | 'backgroundColor'
    | 'padding'
    | 'overflow'
    | 'margin'
    | 'style'
  >
>`
  width: ${(props) => props.width || '100%'};
  max-height: ${(props) => props.maxHeight || '100%'};
  min-height: ${(props) => props.minHeight || 'calc(100vh - 60px)'};
  height: ${(props) => props.height || '100%'};
  background-color: ${(props) => props.backgroundColor || colors.lightest};
  padding: ${(props) => props.padding || '20px'};
  overflow: ${(props) => props.overflow || 'auto'};
  margin: ${(props) => props.margin || '0px'};
`

export function PixelPageContainer(props: PixelPageContainerProps) {
  return (
    <StyledPixelPageContainer {...props} style={props.style}>
      {props.children}
    </StyledPixelPageContainer>
  )
}

export default PixelPageContainer
